import Locale from 'antd/es/locale/en_US';
const locale = {
  ...Locale.Pagination,
  oneTotalText: 'Toal 1 item',
  moreTotalText: 'Toal {totalCount} items'
};
export default locale;